<script>
    import NumberInput from "../atoms/NumberInput.svelte";
    import AlternateButton from "./AlternateButton.svelte";


    export let positionValue;
    export let valid;
    export let maxValue;
    export let onClick;
</script>

<NumberInput bind:value={positionValue} text="Position " id="pos" maxValue={maxValue} />
<AlternateButton condition={valid} onClick={onClick} value="Envoyer" />